import { STORE_ROOT } from 'utils/constants/urls';
import { addDataToStore } from 'utils/helpers/localStorageHelpers';
import { UserSession } from 'utils/types/sessionTypes';

import { BaseRequestError } from './request';

export const getUserSession = async () => {
  const response = await fetch(`${STORE_ROOT}/sessions/status.json`, {
    credentials: 'include',
  });
  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new BaseRequestError(
      `Request failed with status code ${response.status}`,
      response,
      data,
    );
  }

  // Prime local store auth (replaces former StoreApi.defaults.headers.Authorization
  // priming) so subsequent getAuthToken()/fetch callers use this session's JWT.
  if (data) {
    addDataToStore(data);
  }

  return {
    data: data as UserSession,
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
  };
};
